import { render, staticRenderFns } from "./PcSettingTab.vue?vue&type=template&id=e2be14cc"
import script from "./PcSettingTab.vue?vue&type=script&lang=js"
export * from "./PcSettingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports